export default "__VITE_ASSET__ak1hXLxk__"